import { Tabs, TabsProps } from "antd";
import React from "react";
import { useSearchParams } from "react-router-dom";
import CandidateJobApplications from "./CandidateJobApplications";
import CandidateResumes from "./CandidateResumes";
import CandidateBasicDetails from "./CandidateBasicDetails";
import { User } from "../../../Entities/User";
import { JobApplication } from "../../../Entities/JobApplication";
import { UserProfile } from "../../../Entities/UserProfile";

interface CandidateDetailsContentProps {
  candidate: User | null;
  recentApplication: JobApplication | null;
  recentResume: UserProfile | null;
}

const CandidateDetailsContent: React.FC<CandidateDetailsContentProps> = ({
  candidate,
  recentApplication,
  recentResume,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab") ?? "details";

  if (!candidate) {
    return null;
  }

  const getContentByTab = () => {
    if (tab === "applications") {
      return <CandidateJobApplications candidate={candidate} />;
    } else if (tab === "resumes") {
      return <CandidateResumes candidate={candidate} />;
    } else {
      return (
        <CandidateBasicDetails
          candidate={candidate}
          recentApplication={recentApplication}
          recentResume={recentResume}
        />
      );
    }
  };

  const items: TabsProps["items"] = [
    {
      key: "details",
      label: "Details",
    },
    {
      key: "applications",
      label: `Applications`,
    },
    {
      key: "resumes",
      label: `Resumes`,
    },
  ];

  return (
    <div className="candidate-details-content">
      <Tabs
        activeKey={tab}
        onChange={(key) => setSearchParams({ tab: key }, { replace: true })}
        items={items}
        size="small"
      />
      <div className="candidate-details-tab-content hide-scroll-bar">
        {getContentByTab()}
      </div>
    </div>
  );
};

export default CandidateDetailsContent;
